import * as React from 'react'
import { cn } from '@/lib/utils'

type FloatingActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string
}

export function FloatingActionButton({
  label,
  className,
  type = 'button',
  ...props
}: FloatingActionButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cn(
        'fixed bottom-[calc(5rem+env(safe-area-inset-bottom))] right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-60 lg:bottom-4',
        className,
      )}
      {...props}
    />
  )
}
